/**
 * Shared metadata for every legal document.
 *
 * Two rules the copy in this folder follows:
 *
 * 1. **No invented facts.** Everything stated about how the platform behaves
 *    was read off the code (the apps, `packages/api`, the auth BFF) or off the
 *    integration notes in `docs/`. If a behaviour is not implemented, the copy
 *    does not promise it.
 * 2. **No invented business identity.** Company name, address, phone, email,
 *    Grievance Officer and the court city are never hard-coded: the copy uses
 *    the placeholders below and `LegalPage` fills them from
 *    `GET /general-settings`, so the admin panel stays the single source of
 *    truth. Each placeholder has a safe fallback, and sentences are written so
 *    they still read correctly when a detail is missing.
 *
 * Placeholders available to the copy:
 *   {company}   company_name                     → "Astro Raju Maharaj"
 *   {site}      website_url                      → "astrorajumaharaj.com"
 *   {email}     support_email / email            → "our support email address"
 *   {phone}     support_phone / phone            → "our support number"
 *   {address}   address                          → "our registered address in India"
 *   {contact}   " at <email> or <phone>"         → "" when neither is set
 *   {officer}   grievance_officer_name           → "The Grievance Officer"
 *   {gemail}    grievance_email / support_email  → the support email fallback
 *   {city}      jurisdiction_city                → "New Delhi"
 */

/** Bump this whenever the substance of any document in this folder changes. */
export const LAST_UPDATED = 'Last updated: 30 October 2026'

/** Legal entity-neutral fallback used in the copy when no company name is set. */
export const BRAND_FALLBACK = 'Astro Raju Maharaj'

/**
 * Every legal document, in the order they are listed to the reader. `LegalPage`
 * renders this as the "Related documents" nav at the foot of each page, which
 * is what makes the set navigable without a dedicated index page.
 */
export const LEGAL_DOCS = [
  { slug: 'terms-of-service', title: 'Terms of Service', blurb: 'The agreement that governs your use of our websites and services.' },
  { slug: 'privacy-policy', title: 'Privacy Policy', blurb: 'What personal data we collect, why, who we share it with, and your rights.' },
  { slug: 'cookie-policy', title: 'Cookie Policy', blurb: 'The cookies and local storage our sites use, and how to control them.' },
  { slug: 'refund-policy', title: 'Cancellation & Refund Policy', blurb: 'Cancelling, rescheduling, returning and getting your money back.' },
  { slug: 'shipping-policy', title: 'Shipping & Delivery Policy', blurb: 'Dispatch and delivery timelines, charges, tracking and failed deliveries.' },
  { slug: 'disclaimer', title: 'Disclaimer', blurb: 'The limits of astrological guidance, and the claims we do not make.' },
  { slug: 'grievance-redressal', title: 'Grievance Redressal', blurb: 'How to escalate a complaint, and the timelines we are bound to.' },
]
